import Vue from 'vue';

const defaultState = {
    woTemplate: {},
};

const mutations = {
    // Client in the URL
    setWOTemplate(state, woTemplate) {
        Vue.set(state, 'woTemplate', woTemplate);
    },
    resetWOTemplate(state) {
        Object.assign(state, { ...defaultState });
    },
};

const actions = {
    async getWOTemplateInfo({ commit, dispatch }, contactId) {
        try {
            const { data } = await this.$rq.getWOTemplateInfo(contactId);
            commit('setWOTemplate', data);
        } catch (err) {
            dispatch('resetWOTemplateInfo');
        }
    },
    resetWOTemplateInfo({ commit }) {
        commit('resetWOTemplate');
    },
};

const getters = {
    woTemplate: state => state.woTemplate,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
